import { render, staticRenderFns } from "./articleList.vue?vue&type=template&id=a0a803ac&scoped=true&"
import script from "./articleList.vue?vue&type=script&lang=js&"
export * from "./articleList.vue?vue&type=script&lang=js&"
import style0 from "./articleList.vue?vue&type=style&index=0&id=a0a803ac&prod&lang=css&"
import style1 from "./articleList.vue?vue&type=style&index=1&id=a0a803ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a803ac",
  null
  
)

export default component.exports